<template>
    <div>
        <p>{{ answer }}</p>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "date-question",
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        answer() {
            let answer = this.question.answer;
            if (answer) {
                let date = moment(answer, "YYYY-MM-DDTHH:mm:ss");
                return date.format("DD/MM/yyyy");
            }
            return "-";
        },
    },
};
</script>